<template>
  <b-button variant="primary" block class="position-relative" :class="{'disabled': disabled}"
      @click="download()">{{ labelToDisplay }}
  </b-button>
</template>

<script>
import {saveAs} from 'file-saver';
import metric_message from "@/domain/metrics/message";

export const SIZE_HD = 'HD'
export const SIZE_SD = 'SD'
export const SIZE_HD_VIDEO = 'V-HD'
export default {
  props: {
    hasPicaServicePhotoOriginal: {
      type: Boolean,
      required: false
    },
    dtPhotosHdAvailableFormatted: {
      type: String,
      required: false
    },
    label: {
      type: String,
      required: false,
      default: 'Download'
    },
    mediaUrl: {
      type: String,
      required: true
    },
    size: {
      type: String,
      required: true
    },
    id: {
      type: [String, Number],
      required: false
    }
  },
  computed: {
    disabled() {
      return this.hasPicaServicePhotoOriginal && !this.mediaUrl
    },

    labelToDisplay() {
      if (!this.mediaUrl && this.dtPhotosHdAvailableFormatted && this.hasPicaServicePhotoOriginal && (this.size === SIZE_HD || this.size === SIZE_HD_VIDEO)) {
        return this.$t('collage_photo_item.download_hd_available_from', {
          date: this.dtPhotosHdAvailableFormatted
        })
      }
      return this.label
    },
    fileName() {
      let name = this.mediaUrl.split('?').shift().split('/').pop()
      if (name.indexOf('.') === -1) name = `${this.id}_${this.size}.jpg`
      return name
    }
  },

  methods: {
    async download() {
      metric_message.photoDownloaded(this.id, this.size === SIZE_HD_VIDEO)
      this.$emit('click')
      return await this.forceDownload()
    },
    async forceDownload() {
      try {
        const response = await fetch(this.mediaUrl, {
          method: 'GET',
          mode: 'cors',
        });
        const fileBlob = await response.blob()
        saveAs(fileBlob, this.fileName)
      } catch (error) {
        location.href = this.mediaUrl
      }
      return false
    }
  }
}
</script>